export const CREATE_DASHBOARD_ITEM_NAME = "create_dashboard_item";

export const CREATE_DASHBOARD_ITEM_DESC = `Creates a dashboard item (metric card or divider) inside an existing dashboard.

Use when the user wants to add Search Analytics / User Analytics metrics, Index Worker metrics, or a divider to a dashboard.

Inputs:
- 'dashboardId' (required): Target dashboard ID.
- 'featureId' (required): Base64-encoded ID of the feature to visualize. Must decode to one of SearchAnalyticsProject, UserAnalyticsProject, IndexWorker, SearchAnalyticsView, or UserAnalyticsView.
- 'type' (required): Dashboard item type. One of SA_CLICK, SA_IMP, SA_CTR, SA_RANK, SA_UNIQ_QUERY, SA_UNIQ_URL, IW_CRAWL, IW_INDEX, IW_NOT_INDEX, UA_SESSION_COUNT, UA_UNIQUE_USER_COUNT, UA_CONVERSION_RATE, UA_SURF_RATE, UA_ENGAGEMENT_RATE, UA_CONVERSION_COUNT, UA_PAGE_VIEW_EVENT_COUNT.
- 'position' (optional): Where to insert the item. 'top' inserts at the beginning, 'bottom' appends to the end. Defaults to 'bottom'.

Notes:
- Performs a write mutation and returns the created item's ID plus dashboard path/url when available.`;
